

import React, { useEffect, useContext } from "react";
import { SessionContext } from "./state/SessionContext";

import { StarFill} from "react-bootstrap-icons";
import { SESSION_ACTIONS } from "./state/SessionReducer";
import { postCommand, sendCommand } from "../components/Bridge";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { Cards, CurrencySign, GameSpecialtyIcons, GameStructureIcons, GameVariantIcons, getCardColor, getCardText, nFormatter, RoomTypeIcons } from "../../api/ReplayVariables";
import FormattedDuration from "react-intl-formatted-duration";

function SessionCard({row, match}){

    const { sessionState, dispatchSessionState  } = useContext(SessionContext);

    const { t } = useTranslation();

    const openRow = () => {
        dispatchSessionState({
            type: SESSION_ACTIONS.OPEN_ROW,
            sessionId: row.id,
            heroId : match.params.hero
        });
    };
    const openNotes = () => {
      //sendCommand("session/replay", {sessionId : row.id, heroId : 0});
    };
    const toggleBookmark = () => {
        dispatchSessionState({
          type: SESSION_ACTIONS.TOGGLE_BOOKMARKS,
          ids: [row.id],
          bookmark : !row.bookmark
        });
      };
      
    const sessionType= parseInt(match.params.sessionType);
  
    useEffect(()=>{
        //console.log("SessionCell effect");

        return (()=>{
            //console.log("SessionCell effect done");
        });
    }, []);

    let iconsHtml = <>
      <div>{row.nbSeats}</div>
      <img src={GameVariantIcons[row.gameVariant]} alt={row.gameVariant} />
      {sessionType === 1 ? <>
        <img src={GameStructureIcons[row.structureType]} alt={row.structureType} />
        <img src={GameSpecialtyIcons[row.gameSpecialty]} alt={row.gameSpecialty} />
      </> : <></>}
    </>;

    let buyinHtml = "";
    let buyinName = "";
    if (sessionType === 1) {
      buyinName = t("app.session.columns.buyin.name");
      if (row.buyInWithRake >= 0) {
        if (row.buyInWithRake !== 0 || row.currency !== "PLAYMONEY") {
          if (row.rake > 0) {
            buyinHtml += nFormatter(row.buyInWithRake - row.rake) + "+" + nFormatter(row.rake) + " " + CurrencySign[row.currency];
          } else {
            buyinHtml += nFormatter(row.buyInWithRake) + " " + CurrencySign[row.currency];
          }
        } else {
          buyinHtml += " ";//t("row.currency.-2");
        }
        let nbRebuysAddons = row.nbRebuys;
        buyinHtml += "";
        if (nbRebuysAddons > 0) {
          if (row.rebuy === 0) {
            buyinHtml += " + " + nbRebuysAddons + "x" + nFormatter(row.buyInWithRake);
          } else {
            buyinHtml += " + " + nbRebuysAddons + "x" + nFormatter(row.rebuy);
          }
        }
      } else {
        buyinHtml += "-";
        buyinName = t("app.session.columns.buyin.name");
      }
    } else {
      buyinName = t("app.session.columns.limit.name");
      buyinHtml = nFormatter(row.bbCashGame / 2) + " / " + nFormatter(row.bbCashGame) + " " + CurrencySign[row.currency];
    }

    let seconds = (row.endDate - row.startDate) / 1000;
    let timeSpentHtml = <></>;
    if (seconds >= 60)
      timeSpentHtml =
        <FormattedDuration
          seconds={seconds}
          format="{hours} {minutes}"
          unitDisplay="narrow"
        />
        ;
    else
      timeSpentHtml =
        <FormattedDuration
          seconds={seconds}
          format="{seconds}"
          unitDisplay="narrow"
        />
        ;

    let finishOrRakeHtml = <></>;
    if (sessionType === 1) {
      if (row.nbPlayers > 10000 || row.finish > 10000) {
        if (row.finish > 0 && (row.nbPlayers <= 0 || row.finish <= row.nbPlayers)) {
          if (row.nbPlayers > 1) {
            finishOrRakeHtml = <><b>{row.finish}</b> / {row.nbPlayers}</>;
          } else {
            finishOrRakeHtml = <><b>{row.finish}</b> / -</>;
          }
        } else if (row.finish > row.nbPlayers) {
          if (row.nbPlayers > 1) {
            finishOrRakeHtml = <><b>?</b> / {row.nbPlayers}</>;
          } else {
            finishOrRakeHtml = <><b>?</b> / -</>;
          }
        } else {
          if (row.nbPlayers > 1) {
            finishOrRakeHtml = <><b>-</b> / {row.nbPlayers}</>;
          } else {
            finishOrRakeHtml = <><b>-</b> / -</>;
          }
        }
      } else {
        if (row.finish > 0 && (row.nbPlayers <= 0 || row.finish <= row.nbPlayers)) {
          if (row.nbPlayers > 1) {
            finishOrRakeHtml = <><b>{row.finish}</b> / {row.nbPlayers}</>;
          } else {
            finishOrRakeHtml = <><b>{row.finish}</b> / -</>;
          }
        } else if (row.finish > row.nbPlayers) {
          if (row.nbPlayers > 1) {
            finishOrRakeHtml = <><b>?</b> / {row.nbPlayers}</>;
          } else {
            finishOrRakeHtml = <><b>?</b> / -</>;
          }
        } else {
          if (row.nbPlayers > 1) {
            finishOrRakeHtml = <><b>-</b> / {row.nbPlayers}</>;
          } else {
            finishOrRakeHtml = <><b>-</b> / -</>;
          }
        }
      }
    } else {
      if (row.rake >= 0) {
        finishOrRakeHtml = nFormatter(row.rake) + " " + CurrencySign[row.currency];
      } else {
        finishOrRakeHtml = "-";
      }

    }

    let resultsHtml = <></>;
    if (sessionType === 1) {
      //gain
      let gainHtml = <></>;
      if (row.totalBounty > 0) {
        if (row.gain > 0) {
          gainHtml = <div>{nFormatter(row.gain)} {CurrencySign[row.currency]}<br />KO={nFormatter(row.totalBounty)} {CurrencySign[row.currency]}<div className="ok"></div></div>;
        } else if (row.gain === 0) {
          if (row.dataProblem) {
            gainHtml = <div>{nFormatter(row.gain)} {CurrencySign[row.currency]}<br />KO={nFormatter(row.totalBounty)} {CurrencySign[row.currency]}<div className="disabled"></div></div>;
          } else {
            gainHtml = <div>{nFormatter(row.gain)} {CurrencySign[row.currency]}<br />KO={nFormatter(row.totalBounty)} {CurrencySign[row.currency]}<div className="ko"></div></div>;
          }
        }
      } else {
        if (row.gain > 0) {
          gainHtml = <div>{nFormatter(row.gain)} {CurrencySign[row.currency]}<div className="ok"></div></div>;
        } else if (row.gain === 0) {
          if (row.dataProblem) {
            gainHtml = <div>{nFormatter(row.gain)} {CurrencySign[row.currency]}<div className="disabled"></div></div>;
          } else {
            gainHtml = <div>{nFormatter(row.gain)} {CurrencySign[row.currency]}<div className="ko"></div></div>;
          }
        } else {
          gainHtml = <></>;
        }
      }

      //netgain
      let amountNet = row.netGain;
      let netgainHtml = <></>;
      if (!row.dataProblem) {
        if (amountNet > 0) {
          netgainHtml = <div>+{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="ok"></div></div>;
        } else if (amountNet < 0) {
          netgainHtml = <div>{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="ko"></div></div>;
        } else {
          netgainHtml = <div>&nbsp;{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="disabled"></div></div>;
        }
      } else {
        netgainHtml = <div>{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="disabled"></div></div>;
      }
      resultsHtml = <>
        <tr>
          <td>{t("app.session.columns.gain.name")}
          </td>
          <td>{gainHtml}
          </td>
        </tr>
        <tr>
          <td>{t("app.session.columns.netgain.name")}
          </td>
          <td>{netgainHtml}
          </td>
        </tr>
      </>;
    } else {
      //vshero
      let amountNet = row.netChipsVsHero;
      let vsHeroHtml = <></>;
      if (amountNet > 0) {
        vsHeroHtml = <div>+{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="ok"></div></div>;
      } else if (amountNet < 0) {
        vsHeroHtml = <div>{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="ko"></div></div>;
      } else {
        vsHeroHtml = <div>&nbsp;{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="disabled"></div></div>;
      }
      //net ev
      amountNet = row.netChipsEV;
      let netEvHtml = <></>;
      if (amountNet > 0) {
        netEvHtml = <div>+{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="ok"></div></div>;
      } else if (amountNet < 0) {
        netEvHtml = <div>{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="ko"></div></div>;
      } else {
        netEvHtml = <div>&nbsp;{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="disabled"></div></div>;
      }
      //net
      amountNet = row.netGain;
      let netHtml = <></>;
      if (!row.dataProblem) {
        if (amountNet > 0) {
          netHtml = <div>+{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="ok"></div></div>;
        } else if (amountNet < 0) {
          netHtml = <div>{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="ko"></div></div>;
        } else {
          netHtml = <div>&nbsp;{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="disabled"></div></div>;
        }
      } else {
        netHtml = <div>{nFormatter(amountNet)} {CurrencySign[row.currency]}<div className="disabled"></div></div>;
      }
      resultsHtml = <>
        <tr>
          <td>{t("app.session.columns.netgain_vshero.name")}
          </td>
          <td>{vsHeroHtml}
          </td>
        </tr>
        <tr>
          <td>{t("app.session.columns.netgain_ev.name")}
          </td>
          <td>{netEvHtml}
          </td>
        </tr>
        <tr>
          <td>{t("app.session.columns.netgain.name")}
          </td>
          <td>{netHtml}
          </td>
        </tr>
      </>;
    }

    let lastHandHtml = <></>;
    if (row.gameVariant.indexOf("HOLD_EM") !== -1) {
      lastHandHtml = <><div className="color" style={{ backgroundColor: row.handColor }}></div><img src={Cards["card" + row.card1]} alt="" /><img src={Cards["card" + row.card2]} alt="" /></>;
    } else {
      lastHandHtml = <><div className="color" style={{ backgroundColor: row.handColor }}></div><img src={Cards["card" + row.card1]} alt="" /><img src={Cards["card" + row.card2]} alt="" /><img src={Cards["card" + row.card3]} alt="" /><img src={Cards["card" + row.card4]} alt="" /></>;
    }


    return (
      <>
        <StarFill size="16" className={"bookmark" + (row.bookmark ? " bookmarked" : "")} onClick={() => this.toggleBookmark(row)}></StarFill>
        <div className="header">
          <img src={RoomTypeIcons[row.roomType]} alt={row.roomType} />
          <div className="category" style={{ backgroundColor: row.categoryColor }}></div>
          <div>
            <div className="name">{row.htmlname}</div>
            <div className="details">{t("app.daysOfWeek." + row.dayOfWeek)} {new Intl.DateTimeFormat(i18n.language, {
              year: "numeric",
              month: "short",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit"
            }).format(Date.parse(row.startDate))}</div>
          </div>
        </div>
        <div className="infos">
          <table>
            <tbody>
              <tr>
                <td className="icons">{iconsHtml}</td>
                <td className="infos-details">
                  <table>
                    <tbody>
                      <tr>
                        <td>{t("app.session.columns.time_spent.name")}</td>
                        <td>{timeSpentHtml}</td>
                      </tr>
                      <tr>
                        <td>{t("app.session.columns.nbHands.name")}</td>
                        <td>{row.nbHands}</td>
                      </tr>
                      <tr>
                        <td>{buyinName}</td>
                        <td>{buyinHtml}</td>
                      </tr>
                      {sessionType === 1 ? <tr>
                        <td>{t("app.session.columns.finish.name")}</td>
                        <td>{finishOrRakeHtml}</td>
                      </tr> : <tr>
                        <td>{t("app.session.columns.rake.name")}</td>
                        <td>{finishOrRakeHtml}</td>
                      </tr>}
                      {resultsHtml}
                    </tbody>
                  </table>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="last-hand">
          <div className="name"><div>{t("app.session.columns.last_hand.name")}</div></div>
          <div className="cards">{lastHandHtml}          {row.percentage >= 0 ?
            <div className="percentage">{row.percentage} %</div> : <></>}
          </div>
        </div>
      </>
    );
}
export default SessionCard;